import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionModalidadSectorialByID = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionModalidadSectorialByID = () => {
  const [loadingGetPrestacionModalidadSectorialByID, setLoadingPrestacionModalidadSectorialByID] = useState(false);
  const [successGetPrestacionModalidadSectorialByID, setSuccessPrestacionModalidadSectorialByID] = useState(false);
  const [errorGetPrestacionModalidadSectorialByID, setErrorPrestacionModalidadSectorialByID] = useState<any>(null);
  const [dataGetPrestacionModalidadSectorialByID, setDataPrestacionModalidadSectorial] = useState<any>(null);

  const [statusGetPrestacionModalidadSectorialByID, setStatusGetPrestacionModalidadSectorialByID] =
    useState<StatusGetPrestacionModalidadSectorialByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPrestacionModalidadSectorialByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingPrestacionModalidadSectorialByID(true);
    setSuccessPrestacionModalidadSectorialByID(false);
    setErrorPrestacionModalidadSectorialByID(null);

    try {
      const res = await apiRecord.getSolicitudModalidadSectorialByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetPrestacionModalidadSectorialByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessPrestacionModalidadSectorialByID(true);
      setDataPrestacionModalidadSectorial(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPrestacionModalidadSectorialByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorPrestacionModalidadSectorialByID(err);
      console.error("Error en getPrestacionModalidadSectorialByID:", err);

      throw err;

    } finally {
      setLoadingPrestacionModalidadSectorialByID(false);
    }
  };

  return {
    getPrestacionModalidadSectorialByID,
    loadingGetPrestacionModalidadSectorialByID,
    successGetPrestacionModalidadSectorialByID,
    errorGetPrestacionModalidadSectorialByID,
    dataGetPrestacionModalidadSectorialByID,
    statusGetPrestacionModalidadSectorialByID
  };
};

export default useGetPrestacionModalidadSectorialByID;
